import { render, staticRenderFns } from "./UISubtitle.vue?vue&type=template&id=13a6315c"
import script from "./UISubtitle.vue?vue&type=script&lang=ts"
export * from "./UISubtitle.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports